module.exports = __webpack_public_path__ + "img/user.bbf247c5.svg";